import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TableSeriesComponent from '../components/TableSeriesComponent';
import FormSeriesComponent from '../components/FormSeriesComponent';
import { validateSession } from '../utils/functions';
import { get } from '../utils/apiClient';
import { listSeries, createSeries, updateSeries } from '../utils/seriesApi';

// Series del club: la plantilla de la jornada que se repite todas las semanas (FR-001,
// FR-002, FR-011). Cada jornada es un evento con `series_id`; acá se ven la próxima, cuántas
// cuántas lleva. Molde de la pantalla: OpenTablesPage / MembershipsPage.
class SeriesPage extends Component {

    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            loading: true,
            series: [],
            branches: [],
            // '' = todas; '1' = activas; '0' = inactivas. Se manda tal cual al backend.
            active: '',
            error: null,
            form: false,        // false | 'alta' | la serie que se está editando
            guardando: false,
            aviso: null,
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
        this.loadBranches();
        this.load();
    }

    load = async () => {
        this.setState({ loading: true, error: null });
        try {
            const data = await listSeries(this.state.active === '' ? {} : { active: this.state.active === '1' });
            this.setState({ series: (data && data.series) || [], loading: false });
        } catch (e) {
            this.setState({ error: e.message, loading: false });
        }
    }

    // El listado trae `branch_id` y no el nombre: se resuelve con la lista de sucursales, que
    // ya está cacheada del lado del navegador para el resto del backoffice.
    loadBranches = async () => {
        try {
            this.setState({ branches: (await get('branch')) || [] });
        } catch (e) {
            this.setState({ branches: [] });   // sin nombre se muestra el id; no es motivo de error
        }
    }

    branchName = (branchId) => {
        const branch = this.state.branches.find((b) => Number(b.id) === Number(branchId));
        return branch ? branch.name : `Sucursal ${branchId}`;
    }

    guardar = async (payload) => {
        const editando = this.state.form && this.state.form !== 'alta' ? this.state.form : null;
        const data = editando
            ? await updateSeries(editando.id, payload)
            : await createSeries(payload);
        const serie = (data && data.series) || {};
        this.setState({
            form: false,
            aviso: editando
                ? `Serie "${serie.name}" actualizada.`
                : `Serie "${serie.name}" creada. Agregale la primera jornada desde "Ver jornadas".`,
        }, this.load);
    }

    // FR-002: la baja es lógica — conserva el historial y deja de ofrecer "Nueva jornada".
    toggleActive = async (serie) => {
        const activa = !!serie.active;
        const texto = activa
            ? `¿Inactivar "${serie.name}"? Conserva su historial y deja de ofrecer "Nueva jornada".`
            : `¿Activar "${serie.name}"? Vuelve a ofrecer "Nueva jornada".`;
        if (!window.confirm(texto)) return;
        this.setState({ guardando: true });
        try {
            await updateSeries(serie.id, { active: !activa });
            this.setState({ guardando: false, aviso: null }, this.load);
        } catch (e) {
            this.setState({ guardando: false });
            alert(e.message);
        }
    }

    render() {
        if (!this.state.checked) return (<div></div>);
        const editando = this.state.form && this.state.form !== 'alta' ? this.state.form : null;
        return (
            <div className="container-fluid">
                {this.state.form ? (
                    <FormSeriesComponent
                        key={editando ? editando.id : 'alta'}
                        initial={editando}
                        editMode={!!editando}
                        onCancel={() => this.setState({ form: false })}
                        onSave={this.guardar} />
                ) : null}
                <div className="row">
                    <SidebarComponent itemSelected={51} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                {/* minWidth:0 — el header es un .row de Bootstrap y colapsa contra
                                    el botón: "Series del club" quedaba en tres líneas. */}
                                <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                                    <HeaderComponent title="Cafetería" subtitle="Series del club" />
                                </div>
                                <button type="button" className="btn btn-accent text-nowrap"
                                    onClick={() => this.setState({ form: 'alta', aviso: null })}>
                                    + Nueva serie
                                </button>
                            </div>

                            {this.state.aviso ? (
                                <div className="alert alert-success" role="alert">{this.state.aviso}</div>
                            ) : null}

                            <div className="card card-small mb-4">
                                <div className="card-header border-bottom d-flex align-items-center flex-wrap" style={{ gap: 12 }}>
                                    <h6 className="m-0 mr-auto">Series</h6>
                                    <select className="form-control" style={{ width: 'auto' }} value={this.state.active}
                                        onChange={(e) => this.setState({ active: e.target.value }, this.load)}>
                                        <option value="">Todas</option>
                                        <option value="1">Activas</option>
                                        <option value="0">Inactivas</option>
                                    </select>
                                </div>
                                <div className="card-body p-0 pb-3">
                                    <TableSeriesComponent
                                        series={this.state.series}
                                        loading={this.state.loading}
                                        error={this.state.error}
                                        filtrando={this.state.active !== ''}
                                        disabled={this.state.guardando}
                                        branchName={this.branchName}
                                        onEdit={(serie) => this.setState({ form: serie, aviso: null })}
                                        onToggleActive={this.toggleActive} />
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default SeriesPage;
